import {z} from 'zod';

// TODO: not sure wht the server decided to do this - pass us strings instead of numbers even thought it uses numbers internally

export enum DownloadRequestAssetSourceType {
	ASSETS = 'ASSETS', // 1
	COLLECTION = 'COLLECTION', // 2
	FOLDER = 'FOLDER', // 3
	SAVED_SEARCH = 'SAVED_SEARCH', // 4
}

export enum DownloadRequestReviewStatus {
	NO_APPROVAL_REQUIRED = 'NO_APPROVAL_REQUIRED', // 1
	PENDING = 'PENDING', // 2
	COMPLETED = 'COMPLETED', // 3
	JUSTIFIED = 'JUSTIFIED', // 4
}

export enum DownloadRequestApprovalStatus {
	NO_APPROVAL_REQUIRED = 'NO_APPROVAL_REQUIRED', // 1
	PENDING_APPROVAL = 'PENDING_APPROVAL', // 2
	APPROVED = 'APPROVED', // 3
	DENIED = 'DENIED', // 4
}

export const DownloadRequestRequesterSchema = z.object({
	id: z.number().int().positive(),
	firstName: z.string(),
	lastName: z.string(),
	email: z.string().email(),
});

export const DownloadRequestSchema = z.object({
	id: z.number().int().positive(),
	assetSourceType: z.nativeEnum(DownloadRequestAssetSourceType),
	requester: DownloadRequestRequesterSchema.nullable(),
	/** 2021-09-03T15:42:48.123Z */
	requestDate: z.string(),
	approvalCount: z.number().int(),
	reviewStatus: z.nativeEnum(DownloadRequestReviewStatus),
	portalContext: z.string(),
	assetCount: z.number().int(),
});

/** all fields */
export const DownloadRequestField = DownloadRequestSchema.keyof().enum;

export type IDownloadRequest = z.infer<typeof DownloadRequestSchema>;
export type IDownloadRequestRequester = z.infer<
	typeof DownloadRequestRequesterSchema
>;
